import { render, staticRenderFns } from "./ProductPrices.vue?vue&type=template&id=34644a4a&scoped=true&"
import script from "./ProductPrices.vue?vue&type=script&lang=ts&"
export * from "./ProductPrices.vue?vue&type=script&lang=ts&"
import style0 from "./ProductPrices.vue?vue&type=style&index=0&id=34644a4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34644a4a",
  null
  
)

export default component.exports